import { type FC } from "react";
import { type ProductData } from "../../../../models/ProductData";
import ProductDesignation from "../../../../ProductDetails/components/ProductDesignation";
import { ParamComponent } from "../../../../common/components/ParamsGrid";
import { Stacker } from "~/common/components/Stacker/Stacker";
import ProductMMD from "../../../../feature/Product/elements/ProductMMD";

import * as WeightUtils from "../../../../utils/WeightUtils";
import { type WeightData } from "../../../../models/WeightData";
import { getAliases } from "../../../../common/components/Product/ProductAliases";
import { Translation } from "../../../../common/Translation";
import { useTranslation } from "react-i18next";
import { useProductDetailsUrl } from "~/common/components/PackageRestrictionContext/useProductDetailsUrl";

interface OrderTableProductProps {
  product: ProductData;
  weight?: WeightData;
}

const OrderTableProduct: FC<OrderTableProductProps> = ({ product, weight }) => {
  const { t } = useTranslation();

  const url = useProductDetailsUrl(product);
  let designation = (
    <ProductDesignation isPreferred={product.preferred} designation={product.designation} size={"title-medium"} />
  );
  if (url) {
    designation = <a href={url}>{designation}</a>;
  }
  return (
    <div className="scha__order-table__product">
      <Stacker gap={8}>
        {designation}
        {product.marketDesignation && <ProductMMD marketDesignation={product.marketDesignation} />}
      </Stacker>
      {product.shortDescription && (
        <div className="scha__order-table__product__description">
          <Translation {...product.shortDescription} />
        </div>
      )}
      {product.sapMaterialNumber && (
        <ParamComponent label={t("cartPage.table.header.schaId.title")} value={product.sapMaterialNumber} />
      )}
      {getAliases(product, "13-digits").length > 0 && (
        <ParamComponent label={t("product.customerId")} value={getAliases(product, "13-digits").join(", ")} />
      )}
      {weight && <ParamComponent label={t("quoteDetailsPage.table.weight")} value={WeightUtils.text(weight)} />}
    </div>
  );
};

export default OrderTableProduct;
